import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// The provider's brand may name any typeface in the scheme catalogue, so the
// portal ships the catalogue. Relative, not "@shared/...": the standalone
// foyer-portal build aliases @shared to foyer-shared/dist (tsc output, no
// CSS). See the shared-alias-build-lanes note.
import "../shared/fonts/scheme.css";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
